import Vue from "vue";

const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {moment})
